"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FootnotePlaceholder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const rpdf_renderer_1 = require("@surge-global-engineering/rpdf-renderer");
const FootnotePlaceholder = ({ marginTop, style, }) => (jsx_runtime_1.jsx(rpdf_renderer_1.View, { fixed: true, style: {
        position: 'absolute',
        top: '100%',
        width: '100%',
        fontSize: (style === null || style === void 0 ? void 0 : style.fontSize) || 0,
        fontFamily: style === null || style === void 0 ? void 0 : style.fontFamily,
        marginTop,
    }, renderFootnotes: true }, void 0));
exports.FootnotePlaceholder = FootnotePlaceholder;
//# sourceMappingURL=footnote-placeholder.js.map